import { LOGIN, LOG_OUT } from "../constant";

const initState = {
  parkID: "",
  group: "",
  userName: "",
};

export default function Login(state = initState, action) {
  switch (action.type) {
    case LOGIN:
      return {
        parkID: action.payload.parkID,
        group: action.payload.group,
        userName: action.payload.userName,
      };
    case LOG_OUT:
      return {
        initState,
      };
    default:
      return state;
  }
}
